import { useState } from "react";
import { BasicCheckbox, Button, SVG } from "ui";
import {
    CustomComponentProps,
    GeneralModalProps
} from "utils/types/generalTypes";

export type DraftModalProps = CustomComponentProps & GeneralModalProps;
export type DemoItem = {
    id: string | number;
    text: string;
    selected: boolean;
};

const DraftModal = ({ open, setOpen, className, style }: DraftModalProps) => {
    const [edit, setEdit] = useState(false);
    const [items, setItems] = useState<DemoItem[]>([
        {
            id: 1,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 2,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 3,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 4,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 5,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 6,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 7,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 8,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 9,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 10,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 11,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 12,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        },
        {
            id: 13,
            text: "Lorem ipsum dolor sit amet.",
            selected: false
        }
    ]);

    const toggleEdit = () => {
        setEdit(() => !edit);
        deSelectAll();
    };

    const selectAll = () => {
        setItems(items.map((i) => ({ ...i, selected: true })));
    };
    const deSelectAll = () => {
        setItems(items.map((i) => ({ ...i, selected: false })));
    };

    const deleteSelected = () => {
        setItems(items.filter((i) => !i.selected));
    };

    const toggleSelected = (id: string | number, val: boolean) => {
        setItems(items.map((i) => (i.id !== id ? i : { ...i, selected: val })));
    };

    return (
        <div
            className={`incdident-rules-modal modal share-modal is-xsmall has-light-bg ${open ? "is-active" : ""} ${className}`}
            style={style}
        >
            <div
                className="modal-background"
                onClick={() => setOpen(false)}
            ></div>
            <div className="modal-content" style={{ overflow: "visible" }}>
                <div className="card">
                    <div
                        className="card-heading flex-a-center"
                        style={{ justifyContent: "space-between" }}
                    >
                        <div className="d-flex flex-j-center flex-a-center gap-10">
                            <div onClick={() => setOpen(false)}>
                                <SVG
                                    svg="arrow-left"
                                    size={24}
                                    className="light-grey-svg"
                                />
                            </div>
                            <h3 className="fw-500" style={{ margin: 0 }}>
                                Draft
                            </h3>
                        </div>

                        <button
                            className="button is-solid is-primary primary-btn close-modal draft-btn"
                            onClick={() => toggleEdit()}
                            style={{
                                padding: "10px 30px",
                                borderRadius: "0.65rem"
                            }}
                        >
                            {edit ? "Done" : "Edit"}
                        </button>
                    </div>

                    <div
                        className="card-boody"
                        style={{ height: "50vh", overflowY: "auto" }}
                    >
                        <ul className="d-flex flex-j-center flex-a-center flex-col w-full">
                            {items.map((i) => (
                                <li
                                    className="w-full d-flex flex-a-center flex-j-start draft-item"
                                    key={i.id}
                                >
                                    {edit && (
                                        <BasicCheckbox
                                            color=""
                                            name={`check_${i.id}`}
                                            checked={i.selected}
                                            handleClick={() =>
                                                toggleSelected(
                                                    i.id,
                                                    !i.selected
                                                )
                                            }
                                        />
                                    )}
                                    <span
                                        className="w-full text-start cursor-pointer"
                                        onClick={() => setOpen(false)}
                                    >
                                        {i.text}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {edit && (
                        <div className="card-footer d-flex flex-j-between">
                            <Button
                                text="Select All"
                                rounded
                                type="is-phantom"
                                handleClick={() => selectAll()}
                            />
                            <Button
                                text="Delete"
                                rounded
                                type="is-phantom"
                                color="red-button"
                                style={{ color: "red" }}
                                handleClick={() => deleteSelected()}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DraftModal;
